/**
 * Lightweight analytics wrapper using PostHog.
 *
 * Usage:
 *   const { trackEvent } = useAnalytics();
 *   trackEvent("step_completed", { step: 2 });
 */

import { trackEvent as track } from "@/lib/analytics";

type EventName =
  | "form_started"
  | "step_completed"
  | "step_abandoned"
  | "form_submitted"
  | "draft_saved"
  | "draft_resumed"
  | "co_insured_added"
  | "same_as_primary_toggled"
  | "cross_field_warning_shown"
  | "upload_path_chosen"
  | "manual_path_chosen"
  | "upload_started"
  | "upload_bail_out"
  | "extraction_completed"
  | "extraction_failed"
  | "review_screen_viewed"
  | "field_edited_by_user";

export function useAnalytics() {
  const trackEvent = (name: EventName, params?: Record<string, unknown>) => {
    track(name, params);
  };

  return { trackEvent };
}
